 /**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

 import { css } from 'lit';

 /**
  * Progressbar CSS
  */
 export const styles = css`
 
  :host {
   display: inline-block;
   -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
    
 }
 
 .track {
   stroke-width: var(--nile-stroke-width-3, var(--ng-stroke-width-6));
   stroke: var(--nile-circular-progress-bar-track-color-stroke,var(--ng-colors-bg-quaternary));
   opacity: 0.5;
   fill: none;
 }
 
 .progress {
   stroke-width: var(--nile-stroke-width-3,var(--ng-stroke-width-6));
   stroke: var(--nile-circular-progress-bar-progress-color-stroke,var(--ng-colors-fg-brand-primary-600));
   stroke-linecap: round;
   fill: none;
   transform: rotate(270deg);
   transform-origin: center;
   transition: stroke-dashoffset 0.8s ease-in-out;  
 }
 
 .circle__text {
   fill: var(--nile-circular-progress-bar-circle-color-text, var(--ng-colors-text-primary-900));
   text-align: center;
   font-size: var(--nile-type-scale-1, var(--ng-font-size-text-sm));
   font-style: normal;
   font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-semibold));
   line-height: var(--nile-type-scale-1, var(--ng-line-height-text-sm));
   letter-spacing: 0.2px;
 }
 
 .nile-progress-bar__status {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: var(--nile-spacing-xs, var(--ng-spacing-xs));
 }
 
 .nile-progress-bar__message {
   flex-grow: 1;
 }
 
 .nile-progress-bar__percentage {
   white-space: nowrap;
 }
 
 `
 export default [styles];
 
